export enum OnyxToastIntent {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  INFORMATION = 'information',
}

export enum OnyxToastMessage {
  INVALID_DATA = 'invalidData',
  SERVER_ERROR = 'serverError',
  SAVED_CHANGES = 'savedChanges',
  COPIED_TO_CLIPBOARD = 'copiedToClipboard',
  FORM_CHANGES_RESTORED = 'formChangesRestored',
  UPDATED_DATA = 'updatedData',
}
